<div>
  <div class="de-para-modal__overlay" (click)="onFechar()">
    <div
      class="de-para-modal"
      role="dialog"
      aria-modal="true"
      aria-labelledby="de-para-modal-title"
      data-testid="de-para-modal"
      (click)="$event.stopPropagation()"
    >
      <div class="de-para-modal__header">
        <h2 id="de-para-modal-title" class="de-para-modal__title">
          Configuração de Integração Amadeus
        </h2>
        <button
          type="button"
          class="de-para-modal__close"
          aria-label="Fechar"
          data-testid="de-para-modal-close"
          (click)="onFechar()"
        >
          &times;
        </button>
      </div>

      <ul class="nav nav-tabs de-para-modal__tabs" role="tablist">
        <li class="nav-item" role="presentation">
          <button
            type="button"
            class="nav-link"
            [class.active]="aba() === 'de-para'"
            role="tab"
            [attr.aria-selected]="aba() === 'de-para'"
            data-testid="tab-de-para"
            (click)="onSelecionarAba('de-para')"
          >
            Perfil x Plano
          </button>
        </li>
        <li class="nav-item" role="presentation">
          <button
            type="button"
            class="nav-link"
            [class.active]="aba() === 'calendario'"
            role="tab"
            [attr.aria-selected]="aba() === 'calendario'"
            data-testid="tab-calendario"
            (click)="onSelecionarAba('calendario')"
          >
            Calendário x Plano
          </button>
        </li>
      </ul>

      @if (carregando()) {
        <p class="de-para-modal__hint" role="status">Carregando...</p>
      } @else if (aba() === 'calendario') {
        @if (planosCalendario().length === 0) {
          <app-empty-state
            message="Configure a aba 'Perfil x Plano' antes de definir o Calendário da Integração"
          />
        } @else {
          @for (plano of planosCalendario(); track plano.numPlbnf) {
            <div class="de-para-modal__plano-bloco">
              <div class="de-para-modal__plano-cabecalho">
                <h3 class="de-para-modal__plano-titulo">
                  {{ plano.nomePlano }} ({{ plano.numPlbnf }})
                </h3>
                <button
                  type="button"
                  class="btn-primary btn-toolbar"
                  [disabled]="salvandoCalendario() !== null"
                  [attr.data-testid]="'btn-salvar-calendario-' + plano.numPlbnf"
                  (click)="onSalvarCalendarioClick(plano)"
                >
                  @if (salvandoCalendario() === plano.numPlbnf) {
                    Salvando...
                  } @else if (plano.codCltrprf != null) {
                    Trocar
                  } @else {
                    Salvar
                  }
                </button>
              </div>

              @if (semCalendarioVigente(plano.numPlbnf)) {
                <p class="de-para-modal__aviso" role="status">
                  Nenhum calendário vigente para este plano. Os calendários abaixo estão com a
                  vigência encerrada e não podem ser selecionados.
                </p>
              }

              <table class="de-para-modal__table">
                <thead>
                  <tr>
                    <th scope="col"><span class="visually-hidden">Selecionar</span></th>
                    <th scope="col">Código Calendário</th>
                    <th scope="col">Plano</th>
                    <th scope="col">Código Perfil</th>
                    <th scope="col">Data Alteração</th>
                    <th scope="col">Início Vig.</th>
                    <th scope="col">Fim Vig.</th>
                    <th scope="col">Situação</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <input
                        type="radio"
                        class="form-check-input"
                        [name]="'calendario-' + plano.numPlbnf"
                        [checked]="escolhaPorPlano()[plano.numPlbnf] == null"
                        [attr.data-testid]="'radio-sem-calendario-' + plano.numPlbnf"
                        [attr.aria-label]="'Sem calendário para o plano ' + plano.numPlbnf"
                        (change)="onCalendarioRadioChange(plano.numPlbnf, null)"
                      />
                    </td>
                    <td colspan="7">Sem calendário</td>
                  </tr>
                  @for (calendario of calendariosDoPlano(plano.numPlbnf); track calendario.codCltrprf) {
                    <tr [class.de-para-modal__linha-inativa]="calendario.vencido">
                      <td>
                        <input
                          type="radio"
                          class="form-check-input"
                          [name]="'calendario-' + plano.numPlbnf"
                          [checked]="escolhaPorPlano()[plano.numPlbnf] === calendario.codCltrprf"
                          [disabled]="calendario.vencido"
                          [attr.data-testid]="'radio-calendario-' + calendario.codCltrprf"
                          [attr.aria-label]="'Calendário ' + calendario.codCltrprf"
                          (change)="onCalendarioRadioChange(plano.numPlbnf, calendario.codCltrprf)"
                        />
                      </td>
                      <td>{{ calendario.codCltrprf }}</td>
                      <td>{{ calendario.numPlbnf }}</td>
                      <td>{{ calendario.codPrfinv ?? '—' }}</td>
                      <td>{{ calendario.dataAlteracao || '—' }}</td>
                      <td>{{ calendario.dataInicioVig || '—' }}</td>
                      <td>{{ calendario.dataFimVig || '—' }}</td>
                      <td>
                        <span
                          class="de-para-modal__situacao"
                          [class.de-para-modal__situacao--encerrada]="calendario.vencido"
                        >
                          {{ calendario.vencido ? 'Finalizado' : 'Vigente' }}
                        </span>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }
        }
      } @else if (!formAberto()) {
        <div class="de-para-modal__toolbar">
          <button
            type="button"
            class="btn-primary btn-toolbar"
            data-testid="btn-nova-config"
            (click)="onAbrirNovo()"
          >
            Nova configuração
          </button>
        </div>

        @if (configs().length === 0) {
          <app-empty-state
            message="Nenhuma configuração 'Perfil x Plano' cadastrada para esta campanha"
          />
        } @else {
          <table class="de-para-modal__table">
            <thead>
              <tr>
                <th scope="col">Perfil</th>
                <th scope="col">Plano</th>
                <th scope="col">Código Amadeus</th>
                <th scope="col"><span class="visually-hidden">Ações</span></th>
              </tr>
            </thead>
            <tbody>
              @for (config of configs(); track config.idPerfilInvest + '-' + config.numPlbnf) {
                <tr>
                  <td>{{ config.nomePerfil }} ({{ config.idPerfilInvest }})</td>
                  <td>{{ config.nomePlano }} ({{ config.numPlbnf }})</td>
                  <td>
                    {{ config.nomeCodigoAmadeus }} ({{ config.codPrfinv }})
                    @if (config.codUmAmadeus != null) {
                      , CodUM {{ config.codUmAmadeus }}
                    }
                  </td>
                  <td class="de-para-modal__row-actions">
                    <button
                      type="button"
                      class="de-para-modal__icon-btn"
                      aria-label="Editar"
                      data-testid="btn-editar-config"
                      (click)="onEditar(config)"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M14.85 2.15a1.5 1.5 0 0 1 2.12 0l.88.88a1.5 1.5 0 0 1 0 2.12L7.5 15.4l-3.75.85.85-3.75L14.85 2.15Z"
                          stroke="currentColor"
                          stroke-width="1.3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                    <button
                      type="button"
                      class="de-para-modal__icon-btn de-para-modal__icon-btn--danger"
                      aria-label="Excluir"
                      data-testid="btn-excluir-config"
                      (click)="onExcluirClick(config)"
                    >
                      <svg
                        width="18"
                        height="18"
                        viewBox="0 0 20 20"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        aria-hidden="true"
                      >
                        <path
                          d="M4 5.5h12M8 5.5V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v1.5M8.5 9v5M11.5 9v5M5.5 5.5 6.2 16a1 1 0 0 0 1 .9h5.6a1 1 0 0 0 1-.9l.7-10.5"
                          stroke="currentColor"
                          stroke-width="1.3"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </button>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        }
      } @else {
        <div class="de-para-modal__form">
          <div class="de-para-modal__field">
            <label class="de-para-modal__label" for="de-para-perfil-select"
              >Perfil de investimento</label
            >
            @if (modoEdicao()) {
              <p class="de-para-modal__valor-fixo">
                {{ perfilSelecionado()?.nome }} ({{ perfilSelecionado()?.idPerfilInvest }})
              </p>
            } @else if (catalogPares().length === 0) {
              <p class="de-para-modal__hint">
                Nenhum participante desta campanha tem perfil e plano definidos ainda.
              </p>
            } @else if (perfisDisponiveis().length === 0) {
              <p class="de-para-modal__hint">
                Todos os perfis desta campanha já foram configurados.
              </p>
            } @else {
              <select
                id="de-para-perfil-select"
                class="form-select"
                data-testid="select-perfil"
                [value]="perfilSelecionado()?.idPerfilInvest ?? ''"
                (change)="onPerfilSelectChange($event)"
              >
                <option value="" disabled>Selecione um perfil</option>
                @for (perfil of perfisDisponiveis(); track perfil.idPerfilInvest) {
                  <option [value]="perfil.idPerfilInvest">
                    {{ perfil.nome }} ({{ perfil.idPerfilInvest }})
                  </option>
                }
              </select>
            }
          </div>

          <div class="de-para-modal__field">
            <label class="de-para-modal__label" for="de-para-plano-select">Plano</label>
            @if (modoEdicao()) {
              <p class="de-para-modal__valor-fixo">
                {{ planoSelecionado()?.nome }} ({{ planoSelecionado()?.numPlbnf }})
              </p>
            } @else if (!perfilSelecionado()) {
              <p class="de-para-modal__hint">Selecione um perfil para ver os planos disponíveis.</p>
            } @else if (planosDisponiveis().length === 0) {
              <p class="de-para-modal__hint">Nenhum plano disponível para este perfil.</p>
            } @else {
              <select
                id="de-para-plano-select"
                class="form-select"
                data-testid="select-plano"
                [value]="planoSelecionado()?.numPlbnf ?? ''"
                (change)="onPlanoSelectChange($event)"
              >
                <option value="" disabled>Selecione um plano</option>
                @for (plano of planosDisponiveis(); track plano.numPlbnf) {
                  <option [value]="plano.numPlbnf">{{ plano.nome }} ({{ plano.numPlbnf }})</option>
                }
              </select>
            }
          </div>

          <div class="de-para-modal__field">
            <label class="de-para-modal__label" for="de-para-codigo-select">Código Amadeus</label>
            @if (!planoSelecionado()) {
              <p class="de-para-modal__hint">Selecione um plano para ver os códigos disponíveis.</p>
            } @else if (carregandoCodigos()) {
              <p class="de-para-modal__hint">Carregando códigos...</p>
            } @else if (codigosDisponiveis().length === 0) {
              <p class="de-para-modal__hint">Nenhum código Amadeus disponível para este plano.</p>
            } @else {
              <select
                id="de-para-codigo-select"
                class="form-select"
                data-testid="select-codigo"
                [value]="codigoSelecionado()?.codPrfinv ?? ''"
                (change)="onCodigoSelectChange($event)"
              >
                <option value="" disabled>Selecione um código Amadeus</option>
                @for (codigo of codigosDisponiveis(); track codigo.codPrfinv) {
                  <option [value]="codigo.codPrfinv">{{ codigo.nome }}</option>
                }
              </select>
            }
          </div>

          <div class="de-para-modal__form-actions">
            <button
              type="button"
              class="btn-outline-primary btn-toolbar"
              data-testid="btn-cancelar-form"
              (click)="onCancelarForm()"
            >
              Cancelar
            </button>
            <button
              type="button"
              class="btn-primary btn-toolbar"
              data-testid="btn-salvar-config"
              [disabled]="!podeSalvar()"
              (click)="onSalvar()"
            >
              Salvar
            </button>
          </div>
        </div>
      }
    </div>
  </div>

  @if (trocarAlvo(); as alvo) {
    <app-alert-dialog
      title="Trocar calendário"
      [message]="
        'O plano ' +
        alvo.nomePlano +
        ' já usa o ' +
        nomeCalendario(alvo.codCltrprf) +
        '. Deseja trocar para ' +
        nomeCalendario(escolhaPorPlano()[alvo.numPlbnf] ?? null) +
        '?'
      "
      description="A troca vale para todos os perfis deste plano e passa a ser usada na próxima integração."
      confirmLabel="Trocar"
      cancelLabel="Cancelar"
      (confirm)="onConfirmarTroca()"
      (cancel)="onCancelarTroca()"
    />
  }

  @if (excluirAlvo(); as alvo) {
    <app-alert-dialog
      title="Excluir configuração"
      [message]="
        'Deseja realmente excluir a configuração do perfil ' +
        alvo.nomePerfil +
        ' com o plano ' +
        alvo.nomePlano +
        '?'
      "
      confirmLabel="Excluir"
      cancelLabel="Cancelar"
      (confirm)="onConfirmarExclusao()"
      (cancel)="onCancelarExclusao()"
    />
  }
</div>
